export const hover = {
  beforeMount(el: any, binding: any, vnode: any) {
    el.addEventListener(
      "mouseenter",
      function (event) {
        binding.value(event)
      },
      false,
    )
  },
}
